import { Component } from '@angular/core';

@Component({
  selector: 'bmd-fitted-loader',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./fitted-loader.component.scss'],
  templateUrl: './fitted-loader.component.html',
})
export class FittedLoaderComponent {
  constructor() {}
}
